export default __webpack_public_path__ + "static/media/ourservice.b63c0ed0.png";